module.exports = __webpack_public_path__ + "static/media/step-star-blue.717def93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Stepper/assets/step-star-blue.svg
// module id = 1505
// module chunks = 193